
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import TableCell from '@material-ui/core/TableCell';
import { Co2service } from '../../services/bunkermaster/Co2service';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { toast } from 'react-toastify';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';


import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Icon from '@material-ui/core/Icon';
import Energy_Switches from './energy-water-switch'

import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';
import { findRenderedDOMComponentWithClass } from 'react-dom/test-utils';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    textstyles: {
        color: '#ff4717'
    },
    boldClass: {
        fontWeight: 'bold',
        fontSize: "20px"
    },
    visibledone: {
        visibility: 'hidden'
    }

}));

function CoCalculation(props) {

    const classes = useStyles();

    const oninputChange = (value, field) => {

        props.onChange(value, field, props.idx);

    }
    const handleChange = (value, field) => {

        props.onChange(value, field, props.idx);
    }
    return (

        <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
            <div className={classes.root}>
                <Grid container spacing={3} className={"ME_Section"}>

                    <Grid item xs={12} sm={6} md={3}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={1}>


                                <Grid item xs={12} md={12} className="maineengineblk">

                                    <label> 100% Engine MCR &#42; </label>
                                    <BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "mcr")} />  &nbsp; KW &nbsp;

                                </Grid>

                                {/* <Grid item xs={12} md={12}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "mcr")} />  &nbsp; KW &nbsp; </Paper>
                                </Grid> */}

                            </Grid>


                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label >  Start Date &#42;</label>
                                    <BootstrapInput type="datetime-local" className='width200 minwidth' onChange={(e) => oninputChange(e.target.value, "start")} />  &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="datetime-local" className='width200 minwidth' onChange={(e) => oninputChange(e.target.value, "start")} />  &nbsp;   </Paper>
                                </Grid> */}

                            </Grid>

                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label > M/E CTR Start  &#42; </label>
                                    <BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "mc_ctr_start")} />  &nbsp;    Tonnes   &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "mc_ctr_start")} />  &nbsp;    Tonnes   &nbsp; </Paper>
                                </Grid> */}

                            </Grid>
                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label >  Actual Operating Load &#42;</label>
                                    <BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "actual_load")} />  &nbsp; KW &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "actual_load")} />  &nbsp; KW &nbsp; </Paper>
                                </Grid> */}

                            </Grid>
                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label >  Actual Calorific Value (CV) &#42;</label>
                                    <BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "Actual_Calorific_Value")} />  &nbsp;    MJ/Kg   &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "Actual_Calorific_Value")} />  &nbsp;    MJ/Kg   &nbsp; </Paper>
                                </Grid> */}

                            </Grid>
                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label > Calorific Value from Seatrails (High CV) </label>
                                    <BootstrapInput type="number" value={props.data.Calorific_Value_from_Seatrails} />  &nbsp;    MJ/Kg   &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" value={props.data.Calorific_Value_from_Seatrails} />  &nbsp;    MJ/Kg   &nbsp; </Paper>
                                </Grid> */}

                            </Grid>
                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label >  BDN (CV) &#42;</label>
                                    <BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "BDN")} />  &nbsp;    MJ/Kg   &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "BDN")} />  &nbsp;    MJ/Kg   &nbsp; </Paper>
                                </Grid> */}

                            </Grid>





                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper className={classes.paper}>

                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label >  FO Con 100% MCR &#42;  </label>
                                    <BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "fO_Con_100")} />  &nbsp;    g/kWh   &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "fO_Con_100")} />  &nbsp;    g/kWh   &nbsp; </Paper>
                                </Grid> */}

                            </Grid>




                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label >  End Date &#42;</label>
                                    <BootstrapInput type="datetime-local" className="width200 minwidth" onChange={(e) => oninputChange(e.target.value, "end")} />  &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="datetime-local" className="width200 minwidth" onChange={(e) => oninputChange(e.target.value, "end")} />  &nbsp;   </Paper>
                                </Grid> */}

                            </Grid>

                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label >  M/E CTR End &#42; </label>
                                    <BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "mc_ctr_end")} />  &nbsp;    Tonnes   &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "mc_ctr_end")} />  &nbsp;    Tonnes   &nbsp; </Paper>
                                </Grid> */}

                            </Grid>
                            <Grid container spacing={1}>

                                <Grid item xs={12} md={12} className="maineengineblk">
                                    <label >Actual Operating Load % MCR   </label>
                                    <BootstrapInput type="number" disabled className="disabled" value={props.data.Actual_Load_MCR} onChange={(e) => oninputChange(e.target.value, "Actual_Load_MCR")} />  &nbsp;       &nbsp;
                                </Grid>

                                {/* <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" disabled className="disabled" value={props.data.Actual_Load_MCR} onChange={(e) => oninputChange(e.target.value, "Actual_Load_MCR")} />  &nbsp;       &nbsp; </Paper>
                                </Grid> */}

                            </Grid>


                            {/* <Grid container spacing={1}>

                                <Grid item xs={12} md={5}>
                                    <Paper className={classes.paper}>  <label >M/E Load  </label></Paper>
                                </Grid>

                                <Grid item xs={12} md={7} className="ae_switch">
                                    <Paper className={classes.paper}>
                                        <BootstrapInput type="number" onChange={(e) => oninputChange(e.target.value, "me_load")} />
                                        <Energy_Switches className="widthauto"
                                            checked={props.data.me_load_unit}
                                            //onChange={(e) => { setCalcFields({ ...calcFields, ...{ volume: e.target.checked } }) }} 
                                            onChange={(e) => handleChange(e.target.checked, "me_load_unit")}
                                            prefix={"Hp"}
                                            suffix={"Kw"}
                                            bold={classes.boldClass}
                                        />
                                    </Paper>
                                </Grid>

                            </Grid> */}

                        </Paper>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4}>
                        <Paper className={classes.paper}>
                            {/* <Grid container spacing={1} style={{ visibility: "hidden"}}>

                                <Grid item xs={12} md={5}>
                                    <Paper className={classes.paper}>  <label >Total  </label></Paper>
                                </Grid>

                                <Grid item xs={12} md={7}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" disabled className="disabled" value={props.data.total} />  &nbsp;    Hours  &nbsp; </Paper>
                                </Grid>

                            </Grid> */}
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={8} className="maineengineblk">
                                    <label > Fuel in use &#42; </label>
                                    <Select labelId="outlined-label5" className="mr20 bunkerselect  "
                                        onChange={(e) => oninputChange(e.target.value, "fuel_use")}
                                        value={props.data.fuel_use}
                                    >
                                        <MenuItem value={1}>VLSFO</MenuItem>
                                        <MenuItem value={2}>ULSFO</MenuItem>
                                        <MenuItem value={3}>MGO</MenuItem>
                                        <MenuItem value={4}>LNG</MenuItem>
                                    </Select>
                                </Grid>
                                {/* <Grid item xs={12} md={4}>
                                    <Paper className={classes.paper}>
                                        <Select labelId="outlined-label5" className="mr20 bunkerselect  "
                                            onChange={(e) => oninputChange(e.target.value, "fuel_use")}
                                            value={props.data.fuel_use}
                                        >
                                            <MenuItem value={1}>VLSFO</MenuItem>
                                            <MenuItem value={2}>ULSFO</MenuItem>
                                            <MenuItem value={3}>MGO</MenuItem>
                                            <MenuItem value={4}>LNG</MenuItem>
                                        </Select>
                                    </Paper>
                                </Grid> */}
                            </Grid>




                            <Grid container spacing={1}>

                                <Grid item xs={12} md={8} className="maineengineblk">
                                    <label >Total  </label>
                                    <BootstrapInput type="number" disabled className="disabled" value={props.data.total < 0 ? "" : props.data.total} />   &nbsp; Hours
                                </Grid>

                                {/* <Grid item xs={12} md={4}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" disabled className="disabled" value={props.data.total < 0 ? "" : props.data.total} />   Hours   &nbsp; </Paper>
                                </Grid> */}

                            </Grid>
                            <Grid container spacing={1}>

                                <Grid item xs={12} md={8} className="maineengineblk">
                                    <label >M/E FO Consumption  </label>
                                    <BootstrapInput type="number" disabled className="disabled" value={props.data.me_fo_cons < 0 ? "" : props.data.me_fo_cons} />&nbsp; Tonnes
                                </Grid>

                                {/* <Grid item xs={12} md={4}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" disabled className="disabled" value={props.data.me_fo_cons < 0 ? "" : props.data.me_fo_cons} />        Tonnes     &nbsp; </Paper>
                                </Grid> */}

                            </Grid>

                            <Grid container spacing={1}>

                                <Grid item xs={12} md={8} className="maineengineblk">
                                <label style={{ fontWeight: "bold" }}> Well-To-Wake CO<sub>2</sub> Emissions-Calculated  </label>
                                    <BootstrapInput type="number" value={props.data.Well_To_Wake_co2_emission < 0 ? "" : props.data.Well_To_Wake_co2_emission} disabled className="disabled" />&nbsp; Tonnes 
                                </Grid>

                                {/* <Grid item xs={12} md={4}>
                                    <Paper className={classes.paper}><BootstrapInput type="number" value={props.data.Well_To_Wake_co2_emission < 0 ? "" : props.data.Well_To_Wake_co2_emission} disabled className="disabled" /> Tonnes  </Paper>
                                </Grid> */}

                            </Grid>
                            <Grid container spacing={1}>

                                <Grid item xs={12} md={8} className="maineengineblk">
                                     <label > Tank-To-Wake CO<sub>2</sub> Emissions-Calculated</label>
                                     <BootstrapInput type="number"

                                        value={props.data.co2_emission < 0 ? "" : props.data.co2_emission}
                                        disabled className="disabled" />&nbsp; Tonnes   
                                </Grid>

                                {/* <Grid item xs={12} md={4}>
                                    <Paper className={classes.paper}><BootstrapInput type="number"

                                        value={props.data.co2_emission < 0 ? "" : props.data.co2_emission}
                                        disabled className="disabled" />   Tonnes    </Paper>
                                </Grid> */}

                            </Grid>
                            <Box component="div" className="resultbox">
                                <p> CO<sub>2</sub> Emission Calculated :</p>
                                <Box component="div" className="bunkarinput wid180  mar25">

                                    <form className={classes.root} noValidate autoComplete="off">
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={8}>
                                                <Paper className={classes.paper}>   <label >Using a higher CV fuel & Clean hull (t)</label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <Paper className={classes.paper}><BootstrapInput type="number"

                                                    value={props.data.co2_emission_seatrails < 0 ? "" : props.data.co2_emission_seatrails}
                                                    disabled className="disabled" />  Tonnes      </Paper>
                                            </Grid>

                                        </Grid>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={8}>
                                                <Paper className={classes.paper}>  <label > Clean hull conditons (t)</label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <Paper className={classes.paper}><BootstrapInput type="number"

                                                    value={props.data.Clean_hull_conditons < 0 ? "" : props.data.Clean_hull_conditons}
                                                    disabled className="disabled" /> Tonnes      </Paper>
                                            </Grid>

                                        </Grid>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={8}>
                                                <Paper className={classes.paper}>   <label >  Difference in CV from BDN </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <Paper className={classes.paper}><BootstrapInput type="number"

                                                    value={props.data.co2_emission_BDN < 0 ? "" : props.data.co2_emission_BDN}
                                                    disabled className="disabled" />  Tonnes </Paper>
                                            </Grid>

                                        </Grid>
                                        {/* <Box component="div" className="afcv">
                                                            <label className=" width120">HFO   </label>

                                                            <BootstrapInput value={"40.14"} readOnly className="smallbox1 " />  &nbsp;     kJ/g
                                                        </Box>
                                                       */}
                                    </form>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={6} sm={6} md={2} className="pos_relative">
                        <Paper className={classes.paper}>
                            <Box component="span" className="pos_relative_num">
                                {props.idx + 1}
                            </Box>
                            <Box
                                className="pos_relative_img"
                                component="img"
                                display="block"
                                height="100%"
                                width="auto"
                                align="right"

                                src={
                                    process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                                    "assets/images/ME.jpg"
                                }

                            />
 {/* <button type="reset" className={classes.btn4}  onClick={props.vlsfovcalc}>Calculate</button>{''} */}

                        </Paper>
                    </Grid>




                </Grid>

            </div>
        </FormControl>






    );
}
export default CoCalculation;